import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { GridStore } from './shared/GridStore';
import { DictionaryStore } from './shared/DictionaryStore';
import { FormStore } from './shared/FormStore';
import { KeycloakStore } from './shared/KeycloakStore';
import { ProfileStore } from './user/ProfileStore';
import { PageInfoStore } from './shared/PageInfoStore';
import { ErrorStore } from './shared/ErrorStore';
import { ProductStore } from './product/ProductStore';
import { ProductCategoryStore } from './product/ProductCategoryStore';
import { ProductSensitivityStore } from './product/ProductSensitivityStore';
import { PriceZoneStore } from './zone/PriceZoneStore';
import { GroupOfSitesStore } from './site/GroupOfSitesStore';
import { CompetitorSiteStore } from './site/CompetitorSiteStore';
import { CompetitorsPriorityStore } from './site/CompetitorsPriorityStore';
import { SettingsOverviewDTOStore } from './general-settings/SettingsOverviewDTOStore';
import { NotificationStore } from './shared/NotificationStore';
import { TierStore } from './tier/TierStore';
import { FamilyStore } from './family/FamilyStore';
import { DataUploadStore } from './data-upload/DataUploadStore';
import { CompetitorProductStore } from './product/CompetitorProductStore';
import { CompetitorStore } from './competitor/CompetitorStore';
import { DataPairingStore } from './data-pairing/DataPairingStore';
import { SettingsStore } from './general-settings/SettingsStore';
import { SupplierAgreementStore } from './supply/SupplierAgreementStore';
import { SupplierStore } from './supply/SupplierStore';
import { ReleaseStore } from './release/ReleaseStore';
import { ReleaseSelloutStore } from './release/ReleaseSelloutStore';
import { RoundingRuleStore } from './general-settings/RoundingRuleStore';
import { CompetitorPriceStore } from './data-cleaning/CompetitorPriceStore';
import { CategoryCleaningStateStore } from './data-cleaning/CategoryCleaningStateStore';
import { InternalProductPricesStore } from './data-cleaning/InternalProductPricesStore';
import { CRPStore } from './data-cleaning/CRPStore';
import { GlobalSettingsStore } from './global-settings/GlobalSettingsStore';
import { WorkflowAdministrationStore } from './workflow/WorkflowAdministrationStore';
import { ThemeStore } from './theme/ThemeStore';
import { PromotionStore } from './promotion/PromotionStore';
import { GeneralConfigurationsStore } from './general-configurations/GeneralConfigurationsStore';
import { WindowStore } from './window/WindowStore';
import { WindowTypeStore } from './promo-settings/WindowTypeStore';
import { PromoSettingsStore } from './promo-settings/PromoSettingsStore';
import { DummyWindowStore } from './window/DummyWindowStore';
import { SegmentationModelStore } from './promo-settings/SegmentationModelStore';
import { MessageStore } from './shared/MessageStore';
import { WindowItemStore } from './window/WindowItemStore';
import { WindowFileStore } from './window/WindowFileStore';
import { SalesDashboardExcelFileStore } from './general-settings/SalesDashboardExcelFileStore';
import { KpiStore } from './kpi/KpiStore';
import { CurrencyStore } from './currency/CurrencyStore';
import { RouteBlockerStore } from './modal/RouteBlockerStore';
import { ReplePromoStore } from './reple-promo/ReplePromoStore';
import { SelloutTerminationStore } from './sellout/SelloutTerminationStore';
import { DownloadStore } from './shared/DownloadStore';
/**
 * RootStore instantiates all stores, and share references between them.
 */

export var RootStore =
/*#__PURE__*/
function () {
  function RootStore() {
    _classCallCheck(this, RootStore);

    // All library stores are added by default.
    this.storeMap = new Map(); // Models

    this.saveStore(new ErrorStore(this));
    this.saveStore(new GeneralConfigurationsStore(this));
    this.saveStore(new DictionaryStore(this));
    this.saveStore(new GridStore(this));
    this.saveStore(new ProfileStore(this));
    this.saveStore(new KeycloakStore(this));
    this.saveStore(new PageInfoStore(this));
    this.saveStore(new NotificationStore(this));
    this.saveStore(new ProductStore(this));
    this.saveStore(new ProductCategoryStore(this));
    this.saveStore(new ProductSensitivityStore(this));
    this.saveStore(new PriceZoneStore(this));
    this.saveStore(new GroupOfSitesStore(this));
    this.saveStore(new CompetitorSiteStore(this));
    this.saveStore(new SettingsOverviewDTOStore(this));
    this.saveStore(new SettingsStore(this));
    this.saveStore(new FormStore(this));
    this.saveStore(new TierStore(this));
    this.saveStore(new ThemeStore(this));
    this.saveStore(new PromotionStore(this));
    this.saveStore(new FamilyStore(this));
    this.saveStore(new SupplierAgreementStore(this));
    this.saveStore(new SupplierStore(this));
    this.saveStore(new DataUploadStore(this));
    this.saveStore(new CompetitorProductStore(this));
    this.saveStore(new CompetitorsPriorityStore(this));
    this.saveStore(new CompetitorStore(this));
    this.saveStore(new DataPairingStore(this));
    this.saveStore(new ReleaseStore(this));
    this.saveStore(new ReleaseSelloutStore(this));
    this.saveStore(new RoundingRuleStore(this));
    this.saveStore(new CompetitorPriceStore(this));
    this.saveStore(new CategoryCleaningStateStore(this));
    this.saveStore(new InternalProductPricesStore(this));
    this.saveStore(new CRPStore(this));
    this.saveStore(new GlobalSettingsStore(this));
    this.saveStore(new WindowStore(this));
    this.saveStore(new WindowTypeStore(this));
    this.saveStore(new PromoSettingsStore(this));
    this.saveStore(new DummyWindowStore(this));
    this.saveStore(new SegmentationModelStore(this));
    this.saveStore(new WorkflowAdministrationStore(this));
    this.saveStore(new MessageStore(this));
    this.saveStore(new WindowItemStore(this));
    this.saveStore(new WindowFileStore(this));
    this.saveStore(new KpiStore(this));
    this.saveStore(new CurrencyStore(this));
    this.saveStore(new RouteBlockerStore(this));
    this.saveStore(new SalesDashboardExcelFileStore(this));
    this.saveStore(new SelloutTerminationStore(this));
    this.saveStore(new ReplePromoStore(this));
    this.saveStore(new DownloadStore(this));
  }
  /**
   * Save store to the map where the key is from the unique name property.
   * @param store mobx store derived from the Base store
   */


  _createClass(RootStore, [{
    key: "saveStore",
    value: function saveStore(store) {
      this.storeMap.set(store.name, store);
    }
    /**
     * Insert new store.
     * @param Store Instance of the mobx store derived from the Base store
     */

  }, {
    key: "addStore",
    value: function addStore(Store) {
      var store = new Store(this);
      this.saveStore(store);
    }
    /**
     * Try to find store by name.
     * @param name Store unique name
     * @returns Specific store when found, false otherwise
     */

  }, {
    key: "getStore",
    value: function getStore(name) {
      return this.storeMap.get(name);
    }
    /**
     * Convert all stored stores from the map to the object representation.
     * @returns All stores as object. When no store found empty object will be returned.
     */

  }, {
    key: "getAll",
    value: function getAll() {
      var stores = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.storeMap.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          stores[key] = value;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return stores;
    }
  }]);

  return RootStore;
}();
export default new RootStore();